export const calculatePollPercentage = (total: number, count: number) => {
  if (count === 0 && total === 0) return 0
  return Math.round((100 * count) / total)
}